<section class="seguro-tab">
  <!-- ════════════════════════════════════════════════════════════════════════
       1. CARD DA APÓLICE EM VIGOR (ATIVA)
       ════════════════════════════════════════════════════════════════════════ -->
  <div class="apolice-ativa-card" *ngIf="apoliceAtiva">
    <div class="aac-header">
      <div class="aac-header-left">
        <div class="aac-icon">
          <i class="ri-shield-check-line"></i>
        </div>
        <div class="aac-title-box">
          <h3 class="aac-title">
            {{ apoliceAtiva.seguradora }} — {{ apoliceAtiva.tipoSeguro || 'Seguro automóvel' }}
          </h3>
          <span class="aac-sub">Apólice nº {{ apoliceAtiva.numeroApolice }}</span>
        </div>
      </div>

      <div class="aac-header-right">
        <span
          class="badge-status"
          [ngClass]="isVigenciaValida(apoliceAtiva.dataFim) ? 'status-ativo' : 'status-expirado'"
        >
          {{ isVigenciaValida(apoliceAtiva.dataFim) ? 'Ativo' : 'Expirado' }}
        </span>
      </div>
    </div>

    <!-- Grid de Detalhes -->
    <div class="aac-grid">
      <div class="aac-item">
        <span class="aac-label">Tipo de seguro</span>
        <strong class="aac-val">{{ apoliceAtiva.tipoSeguro }}</strong>
      </div>

      <div class="aac-item">
        <span class="aac-label">Início de vigência</span>
        <strong class="aac-val">{{ formatDate(apoliceAtiva.dataInicio) }}</strong>
      </div>

      <div class="aac-item">
        <span class="aac-label">Fim de vigência</span>
        <strong
          class="aac-val"
          [ngClass]="isVigenciaValida(apoliceAtiva.dataFim) ? 'text-success' : 'text-danger'"
        >
          {{ formatDate(apoliceAtiva.dataFim) }}
        </strong>
      </div>

      <div class="aac-item">
        <span class="aac-label">Prémio anual</span>
        <strong class="aac-val">{{ formatKz(apoliceAtiva.premioAnual) }}</strong>
      </div>

      <div class="aac-item">
        <span class="aac-label">Capital seguro</span>
        <strong class="aac-val">{{ formatKz(apoliceAtiva.capitalSeguro) }}</strong>
      </div>

      <div class="aac-item">
        <span class="aac-label">Franquia</span>
        <strong class="aac-val">{{ formatKz(apoliceAtiva.franquia) }}</strong>
      </div>

      <div class="aac-item full-row" *ngIf="apoliceAtiva.contactoSeguradora">
        <span class="aac-label">Contacto da seguradora</span>
        <div class="contact-val">
          <i class="ri-phone-line"></i>
          <strong>{{ apoliceAtiva.contactoSeguradora }}</strong>
        </div>
      </div>
    </div>

    <!-- Botão de Ação -->
    <div class="aac-actions">
      <button
        type="button"
        class="btn-web-primary"
        (click)="openRenovar()"
      >
        <i class="ri-shield-keyhole-line"></i> Renovar / registar seguro
      </button>
    </div>
  </div>

  <!-- EMPTY STATE SE NÃO HOUVER APÓLICE ATIVA -->
  <div class="apolice-empty-card" *ngIf="!apoliceAtiva">
    <div class="aec-icon">
      <i class="ri-shield-line"></i>
    </div>
    <div class="aec-content">
      <strong>Nenhuma apólice de seguro ativa</strong>
      <p>Registe a apólice de seguro em vigor para esta viatura para monitorizar coberturas e prazos de validade.</p>
      <button
        type="button"
        class="btn-web-primary sm"
        (click)="openRenovar()"
      >
        <i class="ri-add-line"></i> Registar Seguro
      </button>
    </div>
  </div>

  <!-- ════════════════════════════════════════════════════════════════════════
       2. LISTA DE APÓLICES ANTERIORES (HISTÓRICO)
       ════════════════════════════════════════════════════════════════════════ -->
  <div class="apolices-anteriores-section">
    <div class="aas-header">
      <h4>Apólices anteriores</h4>
      <p>Histórico de apólices encerradas ou substituídas.</p>
    </div>

    <div class="aas-list" *ngIf="apolicesAnteriores.length > 0">
      <div class="apolice-anterior-item" *ngFor="let a of apolicesAnteriores">
        <div class="aai-left">
          <div class="aai-title-row">
            <strong class="aai-title">{{ a.seguradora }} — {{ a.numeroApolice }}</strong>
          </div>
          <div class="aai-subline">
            <span>{{ a.tipoSeguro }}</span>
            <span class="dot">·</span>
            <span>{{ formatKz(a.premioAnual) }}/ano</span>
            <span class="dot" *ngIf="a.franquia">·</span>
            <span *ngIf="a.franquia">Franquia {{ formatKz(a.franquia) }}</span>
          </div>
        </div>

        <div class="aai-right">
          <span
            class="badge-status"
            [ngClass]="isVigenciaValida(a.dataFim) ? 'status-ativo' : 'status-expirado'"
          >
            {{ isVigenciaValida(a.dataFim) ? 'Ativo' : 'Expirado' }}
          </span>
          <span class="aai-periodo">
            {{ formatDate(a.dataInicio) }} – {{ formatDate(a.dataFim) }}
          </span>
        </div>
      </div>
    </div>

    <!-- Empty state apólices anteriores -->
    <div class="aas-empty" *ngIf="apolicesAnteriores.length === 0">
      <i class="ri-history-line"></i>
      <span>Sem registo de apólices anteriores.</span>
    </div>
  </div>

  <!-- ════════════════════════════════════════════════════════════════════════
       3. DRAWER DE RENOVAÇÃO / REGISTO DE SEGURO
       ════════════════════════════════════════════════════════════════════════ -->
  <p-drawer
    [(visible)]="drawerVisible"
    position="right"
    [modal]="true"
    [blockScroll]="true"
    styleClass="seguro-drawer"
    [header]="apoliceAtiva ? 'Renovar / Registar Seguro' : 'Registar Nova Apólice'"
    (onHide)="closeDrawer()"
  >
    <div class="drawer-form-container">
      <div class="sp-form-grid">
        <!-- Viatura (Bloqueada no detalhe da viatura) -->
        <div class="sp-form-group full-width">
          <label>
            Viatura
            <span class="lock-indicator" *ngIf="viaturaBloqueada || equipamento">
              <i class="ri-lock-line"></i> Vinculada (bloqueada)
            </span>
          </label>

          <!-- Se estiver no detalhe de viatura: campo bloqueado -->
          <div
            class="locked-vehicle-field"
            *ngIf="viaturaBloqueada || equipamento"
            pTooltip="Viatura vinculada a este detalhe de equipamento."
            tooltipPosition="top"
          >
            <i class="ri-car-line vehicle-icon"></i>
            <span class="vehicle-text">{{ viaturaSelecionadaInfo }}</span>
            <i class="ri-lock-2-fill lock-icon"></i>
          </div>

          <!-- Se estiver em contexto global (Frota): selector disponível -->
          <p-select
            *ngIf="!viaturaBloqueada && !equipamento"
            [(ngModel)]="form.equipamentoId"
            [options]="viaturasDisponiveis"
            optionLabel="codigoInterno"
            optionValue="id"
            placeholder="Selecione a viatura..."
            styleClass="w-full"
          />
        </div>

        <!-- Seguradora -->
        <div class="sp-form-group">
          <label>Seguradora <span class="required">*</span></label>
          <p-select
            [(ngModel)]="form.seguradora"
            [options]="seguradorasPredefinidas"
            optionLabel="label"
            optionValue="value"
            placeholder="Selecione a seguradora"
            styleClass="w-full"
          />
        </div>

        <!-- Seguradora Customizada (se selecionado "Outra") -->
        <div class="sp-form-group" *ngIf="form.seguradora === 'Outra'">
          <label>Nome da Seguradora <span class="required">*</span></label>
          <input
            pInputText
            [(ngModel)]="form.seguradoraCustom"
            placeholder="Nome da companhia..."
            class="w-full"
          />
        </div>

        <!-- Nº de Apólice -->
        <div class="sp-form-group">
          <label>Nº de Apólice <span class="required">*</span></label>
          <input
            pInputText
            [(ngModel)]="form.numeroApolice"
            placeholder="Ex: APO-2026-00892"
            class="w-full"
          />
        </div>

        <!-- Tipo de Cobertura -->
        <div class="sp-form-group full-width">
          <label>Tipo de Cobertura <span class="required">*</span></label>
          <p-select
            [(ngModel)]="form.tipoCobertura"
            [options]="tiposCobertura"
            optionLabel="label"
            optionValue="value"
            placeholder="Selecione a cobertura"
            styleClass="w-full"
          />
        </div>

        <!-- Início de Vigência -->
        <div class="sp-form-group">
          <label>Data de Início <span class="required">*</span></label>
          <p-datepicker
            [(ngModel)]="form.dataInicio"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            appendTo="body"
            styleClass="w-full"
          />
        </div>

        <!-- Data de Fim / Validade -->
        <div class="sp-form-group">
          <label>Data de Fim / Validade <span class="required">*</span></label>
          <p-datepicker
            [(ngModel)]="form.dataFim"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            appendTo="body"
            styleClass="w-full"
          />
        </div>

        <!-- Estado Calculado Automaticamente (Informativo) -->
        <div class="sp-form-group full-width state-preview-banner">
          <div class="spb-content">
            <span class="spb-label">Estado previsto da apólice:</span>
            <strong class="spb-value" [ngClass]="estadoPrevistoCalculado.class">
              {{ estadoPrevistoCalculado.label }}
            </strong>
          </div>
          <small class="spb-hint">
            <i class="ri-information-line"></i> O estado é calculado automaticamente a partir da data de fim.
          </small>
        </div>

        <!-- Prémio Anual -->
        <div class="sp-form-group">
          <label>Prémio Anual (Kz)</label>
          <p-inputNumber
            [(ngModel)]="form.premioAnual"
            mode="currency"
            currency="AOA"
            locale="pt-AO"
            [minFractionDigits]="0"
            [maxFractionDigits]="0"
            placeholder="0 Kz"
            styleClass="w-full"
          />
        </div>

        <!-- Capital Segurado -->
        <div class="sp-form-group">
          <label>Capital Segurado (Kz)</label>
          <p-inputNumber
            [(ngModel)]="form.capitalSegurado"
            mode="currency"
            currency="AOA"
            locale="pt-AO"
            [minFractionDigits]="0"
            [maxFractionDigits]="0"
            placeholder="0 Kz"
            styleClass="w-full"
          />
        </div>

        <!-- Franquia -->
        <div class="sp-form-group">
          <label>Franquia (Kz)</label>
          <p-inputNumber
            [(ngModel)]="form.franquia"
            mode="currency"
            currency="AOA"
            locale="pt-AO"
            [minFractionDigits]="0"
            [maxFractionDigits]="0"
            placeholder="0 Kz"
            styleClass="w-full"
          />
        </div>

        <!-- Contacto da Seguradora -->
        <div class="sp-form-group">
          <label>Contacto da Seguradora</label>
          <input
            pInputText
            [(ngModel)]="form.contactoSeguradora"
            placeholder="Ex: +244 222 345 678"
            class="w-full"
          />
        </div>

        <!-- Observações / Coberturas Adicionais -->
        <div class="sp-form-group full-width">
          <label>Observações & Coberturas Adicionais</label>
          <textarea
            pTextarea
            [(ngModel)]="form.observacoes"
            rows="2"
            placeholder="Notas adicionais sobre a apólice ou seguradora..."
            class="w-full"
          ></textarea>
        </div>

        <!-- Upload 1: Apólice de Seguro (PDF) -->
        <div class="sp-form-group">
          <label>Apólice de Seguro (PDF)</label>
          <div class="doc-upload-box">
            <label class="doc-upload-trigger" *ngIf="!apoliceFile">
              <input
                type="file"
                accept=".pdf,application/pdf"
                (change)="onApoliceFileSelected($event)"
                hidden
              />
              <i class="ri-file-pdf-line"></i>
              <span>Carregar Apólice (PDF)</span>
            </label>
            <div class="file-chip" *ngIf="apoliceFile">
              <i class="ri-file-pdf-fill text-danger"></i>
              <span class="file-name">{{ apoliceFile.name }}</span>
              <button type="button" (click)="removeApoliceFile()">
                <i class="ri-close-line"></i>
              </button>
            </div>
          </div>
          <small class="field-hint">Refletido automaticamente na tab Documentação.</small>
        </div>

        <!-- Upload 2: Comprovativo de Pagamento (PDF/JPG) -->
        <div class="sp-form-group">
          <label>Comprovativo de Pagamento (PDF/JPG)</label>
          <div class="doc-upload-box">
            <label class="doc-upload-trigger" *ngIf="!comprovativoFile">
              <input
                type="file"
                accept=".pdf,image/jpeg,image/png,application/pdf"
                (change)="onComprovativoFileSelected($event)"
                hidden
              />
              <i class="ri-receipt-line"></i>
              <span>Carregar Comprovativo</span>
            </label>
            <div class="file-chip" *ngIf="comprovativoFile">
              <i class="ri-file-text-fill text-primary"></i>
              <span class="file-name">{{ comprovativoFile.name }}</span>
              <button type="button" (click)="removeComprovativoFile()">
                <i class="ri-close-line"></i>
              </button>
            </div>
          </div>
          <small class="field-hint">Refletido automaticamente na tab Documentação.</small>
        </div>
      </div>

      <div class="drawer-actions">
        <button
          type="button"
          class="btn-web-secondary"
          (click)="closeDrawer()"
          [disabled]="saving"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="btn-web-primary"
          (click)="salvarApolice()"
          [disabled]="saving"
        >
          <i class="ri-save-line"></i>
          {{ saving ? 'A guardar...' : 'Guardar / Renovar Seguro' }}
        </button>
      </div>
    </div>
  </p-drawer>
</section>
